import type { ShopRecord } from "./types";

export function isOwnedShopId(shops: ShopRecord[], shopId: string): boolean {
  return shops.some((shop) => shop.id.toText() === shopId);
}

export function lastShopKey(principal: string): string {
  return `tillflo-reports:last-shop:${principal}`;
}

export function chooseInitialShop(
  shops: ShopRecord[],
  rememberedId: string | null,
): ShopRecord | undefined {
  return (
    shops.find((shop) => shop.id.toText() === rememberedId) ?? shops[0]
  );
}
